import React from 'react';
import { Link } from 'react-router-dom';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import PageSEO from '@/components/PageSEO';

const ImpressumPage = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* SEO Meta Tags */}
      <PageSEO
        title="Impressum | Handwerkernotdienst NRW"
        description="Impressum der Schössow Dienstleistungen UG (haftungsbeschränkt) - Handwerkernotdienst NRW. Alle rechtlichen Angaben gemäß § 5 TMG."
        canonicalUrl="https://handwerkernotdienst.nrw/impressum"
        breadcrumbs={[
          { name: 'Start', url: 'https://handwerkernotdienst.nrw/' },
          { name: 'Impressum', url: 'https://handwerkernotdienst.nrw/impressum' }
        ]}
      />
      
      <Header />

      <section className="py-16" data-testid="impressum-content">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl font-bold text-gray-900 mb-8" data-testid="impressum-title">Impressum</h1>
          
          <div className="prose prose-lg max-w-none">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Angaben gemäß § 5 TMG</h2>
            <p className="text-gray-700 mb-6">
              <strong>Handwerkernotdienst NRW</strong><br />
              Schössow Dienstleistungen UG (haftungsbeschränkt)<br />
              Neben dem Brand 10<br />
              44135 Dortmund<br />
              Deutschland
            </p>

            <h3 className="text-xl font-bold text-gray-900 mb-3">Vertreten durch</h3>
            <p className="text-gray-700 mb-6">
              Geschäftsführer: Andreas Schoessow
            </p>

            <h3 className="text-xl font-bold text-gray-900 mb-3">Kontakt</h3>
            <p className="text-gray-700 mb-6">
              Telefon: <a href="tel:+4923139083687" className="text-[#0066cc] hover:underline">+49 231 39083687</a><br />
              E-Mail: <a href="mailto:info@handwerkernotdienst.nrw" className="text-[#0066cc] hover:underline">info@handwerkernotdienst.nrw</a>
            </p>

            <h3 className="text-xl font-bold text-gray-900 mb-3">Registereintrag</h3>
            <p className="text-gray-700 mb-6">
              Eintragung im Handelsregister:<br />
              Registergericht: Amtsgericht Dortmund<br />
              Registernummer: HRB 29517
            </p>

            <h3 className="text-xl font-bold text-gray-900 mb-3">Umsatzsteuer-ID</h3>
            <p className="text-gray-700 mb-6">
              Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:<br />
              DE310018782
            </p>

            <h3 className="text-xl font-bold text-gray-900 mb-3">Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h3>
            <p className="text-gray-700 mb-6">
              Andreas Schoessow<br />
              Neben dem Brand 10<br />
              44135 Dortmund
            </p>

            <h3 className="text-xl font-bold text-gray-900 mb-3">EU-Streitschlichtung</h3>
            <p className="text-gray-700 mb-6">
              Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: 
              <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="text-[#0066cc] hover:underline">
                https://ec.europa.eu/consumers/odr/
              </a><br />
              Unsere E-Mail-Adresse finden Sie oben im Impressum.
            </p>

            <h3 className="text-xl font-bold text-gray-900 mb-3">Verbraucherstreitbeilegung / Universalschlichtungsstelle</h3>
            <p className="text-gray-700 mb-6">
              Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
            </p>

            <h3 className="text-xl font-bold text-gray-900 mb-3">Haftungsausschluss</h3>
            
            <h4 className="text-lg font-semibold text-gray-900 mb-2">Haftung für Inhalte</h4>
            <p className="text-gray-700 mb-4">
              Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. 
              Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen 
              oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
            </p>

            <h4 className="text-lg font-semibold text-gray-900 mb-2">Haftung für Links</h4>
            <p className="text-gray-700 mb-4">
              Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. 
              Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige 
              Anbieter oder Betreiber der Seiten verantwortlich.
            </p>

            <h4 className="text-lg font-semibold text-gray-900 mb-2">Urheberrecht</h4>
            <p className="text-gray-700 mb-6">
              Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. 
              Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen 
              der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ImpressumPage;
